module.exports = __webpack_public_path__ + "media/components/country-flag/static/im-2eb4a3241b86ddf7bf65f7cbdd1c3230.svg";